import USER_ROLES from 'constants/user-roles.constant';
import { restrictions } from 'state/features-list/constants';

const globalIntakeRequestModule = {
  form: {
    name: 'confidentialSupportRequest',
    url: '/confidential-support-request',
    resolver: () =>
      import(
        /* webpackChunkName: "confidential-support-request" */ 'pages/global-intake-request/form/global-intake-form'
      ),
    restrictions: {
      user: [restrictions['submit_confidential_request_for_support']],
    },
    data: {
      title: 'global_intake_request.form.title',
      section: 'life',
      authorizedRoles: [USER_ROLES.employee],
      hideFooter: true,
    },
  },
  complete: {
    name: 'confidentialSupportRequestComplete',
    url: '/confidential-support-request/complete',
    resolver: () =>
      import(
        /* webpackChunkName: "confidential-support-request" */ 'pages/global-intake-request/completed/global-intake-completed'
      ),
    restrictions: {
      user: [restrictions['submit_confidential_request_for_support']],
    },
    data: {
      title: 'global_intake_request.completed.title',
      section: 'life',
      authorizedRoles: [USER_ROLES.employee],
      hideFooter: true,
    },
  },
} as const;

export default globalIntakeRequestModule;
